// extracted by mini-css-extract-plugin
module.exports = {"link":"LanguageSwitcher_link__1Rhf0","selected":"LanguageSwitcher_selected__142Pv"};